import * as Sentry from '@sentry/react'
import { inject } from '@vercel/analytics'
import { App, ConfigProvider } from 'antd'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import MSAL from './modules/msal/MSAL'
import AppRoutes from './routes/AppRoutes'
import { store } from './store/store'

if (import.meta.env.VITE_ENVIRONMENT !== 'dev') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api\.rock-your\.careers/,
    ],
    environment: import.meta.env.VITE_ENVIRONMENT,
    release: 'ryc-bo-frontend@' + process.env.npm_package_version,
  })
}

// Enable Vercel analytics
inject({
  mode:
    import.meta.env.VITE_ENVIRONMENT === 'production'
      ? 'production'
      : 'development',
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <BrowserRouter basename="/">
    <MSAL>
      <Provider store={store}>
        <App>
          <ConfigProvider
            theme={{
              token: { colorPrimary: '#6c7cff' },
            }}
          >
            <AppRoutes />
          </ConfigProvider>
        </App>
      </Provider>
    </MSAL>
  </BrowserRouter>
)
